import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Pages/Home';
import About from './Pages/About';
import Services from './Pages/Services';
import Faq from './Pages/Faq';
import Error from './Pages/Error';
import ContactUs from './Pages/ContactUs';
import Projects from './Pages/Projects';
import ProjectDetail from './Pages/ProjectDetail';
import Login from './Pages/Login';
import Register from './Pages/Register';
import GetFreeQuote from './Pages/GetFreeQuote';
import ScrollToTop from './Common/ScrollToTop';

class Components extends React.Component {
    render() {
        return (
            <BrowserRouter basename="/">
                <ScrollToTop />
                <div className="page-wraper">
                        <Routes>
                            <Route path="/"  element={<Home/>} />
                            <Route path='/about' element={<About/>} />
                            <Route path='/services' element={<Services/>} />       
                            <Route path='/faq' element={<Faq/>} />
                            <Route path='/error' element={<Error/>} />
                            <Route path='/contactus' element={<ContactUs/>} />
                            <Route path='/project-detail' element={<ProjectDetail/>} />
                            <Route path='/projects' element={<Projects/>} />
                            <Route path="/login"  element={<Login/>} />
                            <Route path="/register"  element={<Register/>} />
                            <Route path="/get-free-quote"  element={<GetFreeQuote/>} />
                            <Route element={<Error/>} />
                  
                        </Routes>
                </div>
            </BrowserRouter>
        );
    };
};

export default Components;